import Switch from './Switch'

export default Switch



// WEBPACK FOOTER //
// ./src/components/Switch/index.js